import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircleIcon } from 'lucide-react';
const attempts = [{
  title: 'Ignorar el maullido',
  description: 'Imposible cuando vivís en un departamento y tenés miedo de que los vecinos se quejen.'
}, {
  title: 'Darle de comer',
  description: "Solo refuerza el ciclo de 'grito = premio' y genera sobrepeso."
}, {
  title: 'Jugar un ratito antes de acostarte',
  description: 'Mover un plumero sin técnica solo sobreexcita al gato en lugar de agotarlo.'
}, {
  title: 'Usar puntero láser',
  description: "Genera una frustración inmensa porque el gato jamás 'atrapa' la presa, dejándolo más alterado que al principio."
}];
export function FailedAttempts() {
  return <section className="py-10 sm:py-14 relative" data-id="element-98">
      <div className="mx-auto max-w-5xl px-6 lg:px-8" data-id="element-99">
        <FadeIn data-id="element-100">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-10" data-id="element-101">
            ¿Por qué nada de lo que probaste funcionó?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6" data-id="element-102">
          {attempts.map((attempt, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-103">
              <div className="bg-navy-light rounded-2xl p-6 sm:p-8 border border-white/5 h-full transition-colors hover:border-white/10" data-id="element-104">
                <div className="flex items-start gap-4" data-id="element-105">
                  <XCircleIcon className="h-6 w-6 text-red-400 shrink-0 mt-1" data-id="element-106" />
                  <div data-id="element-107">
                    <h3 className="text-xl font-bold text-slate-100 mb-2" data-id="element-108">
                      {attempt.title}
                    </h3>
                    <p className="text-slate-400 font-sans leading-relaxed" data-id="element-109">
                      {attempt.description}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}